import { Authority, EditCompanyUserMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const editCompanyUserHandler = graphql.mutation<EditCompanyUserMutation>(
  "editCompanyUser",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        editCompanyUser: {
          user: {
            sub: "sub1",
            username: "username1",
            authority: Authority.Admin,
            email: "username1@moneyforward.co.jp",
            lastName: "名字(更新後)",
            lastNameKana: "ミョウジコウシンゴ",
            middleName: "ミドルネーム(更新後)",
            middleNameKana: "ミドルネームカナコウシンゴ",
            firstName: "名前(更新後)",
            firstNameKana: "ナマエカナコウシンゴ",
          },
        },
      },
    });
  }
);
